import React from 'react';
import styles from './card.module.scss';

type Props = {
    title: string
    detail: string
    leftIcon?: React.ReactNode;
    isAdmin?: boolean;
}

function TitleCard(props: Props) {
    const { title, detail, leftIcon, isAdmin=false } = props

    return (
        <div className={styles.sectionTitleView}>
            <div className={styles.sectionTitle}>
                {leftIcon}
                <h2>{title}</h2>
                {isAdmin && <div className={styles.adminTag}>{'ADMINISTRATOR'}</div>}
            </div>
            <div className={styles.sectionDetail}>
                {detail}
            </div>
        </div>
    )
}

export default TitleCard